import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=6f85ca0c"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"
import style0 from "./UserView.vue?vue&type=style&index=0&id=6f85ca0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports